import React from 'react'
import { connect } from 'react-redux'
import searchIcon from '../../assets/images/svg_icons/Search.svg'
import '@szhsin/react-menu/dist/index.css'
import './index.css'


const Search = props => {
  const { searchText = '', onSearchTextChange = () => null, onSearch = () => null } = props;

  return <React.Fragment>
      <div className='header__search-container'>
        <div className='header__search'>
          <input placeholder='Buscar'
            value={searchText}
            onChange={e => onSearchTextChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') onSearch()
            }}
          />
          <img src={searchIcon} alt='search' onClick={onSearch} />
        </div>
      </div>
      
  </React.Fragment>
}
const mapStateToProps = state => ({
  settings: state.settings,
  products: state.products
})

export default connect(mapStateToProps)(Search)